// Extraído de PeticionDetail.jsx (refactor mecánico, sin cambios funcionales)
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export function ChipSelect({ value, onChange, options, "data-testid": testid }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testid} className="bg-zinc-900 border-zinc-800 h-8 text-xs"><SelectValue /></SelectTrigger>
      <SelectContent className="bg-zinc-950 border-zinc-800 text-zinc-100">
        {options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
